import React from "react";
import { createPopper } from "@popperjs/core";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { logoutUser } from "components/CommanMethod/Commanmethod";

const UserDropdown = () => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const history = useHistory();

  //this is the code of the logout click
  const handleLogout = () => {
    logoutUser();
    // Redirect to the login page
    history.push("/login");
  };

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);

    userName = userData.userName;
  }

  return (
    <>
      <a
        className="custnav lg:text-black lg:hover:text-blue-200 text-blueGray-900 px-3 py-3 lg:py-2 flex items-center text-xs uppercase font-bold"
        href="#"
        ref={btnDropdownRef}
        onMouseOver={(e) => {
          e.preventDefault();
          openDropdownPopover();
        }}
        onMouseLeave={(e) => {
          e.preventDefault();
          closeDropdownPopover();
        }}
      >
        <img
          src={require("assets/img/icons-admin.png")}
          alt="Logo not found"
          style={{ width: "25px" }}
          title={userName}
        />
        <div
          ref={popoverDropdownRef}
          className={
            (dropdownPopoverShow ? "block " : "hidden ") +
            "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
          }
        >
          <Link
            to="/adminDetails"
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            My Profile
          </Link>
          <Link
            to="/settingsForAdmin"
            className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          >
            Settings
          </Link>

          <Link
            to="/changeAdminPassword"
            className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          >
            Change Password
          </Link>
          <Link
            to="/login"
            onClick={handleLogout}
            className={
              "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            Logout
          </Link>
        </div>
      </a>
    </>
  );
};

export default UserDropdown;
